import { DeconstructedDuration } from './deconstruct-date.function';
import { SECONDS_IN_DAY, SECONDS_IN_HOUR, SECONDS_IN_MINUTE } from './duration.constants';

export function addMillisecondsToDuration(deconstructed: DeconstructedDuration, amount: number): DeconstructedDuration {
  const milliseconds = (deconstructed.milliseconds ?? 0)
    + (deconstructed.seconds ?? 0) * 1000
    + (deconstructed.minutes ?? 0) * 1000 * SECONDS_IN_MINUTE
    + (deconstructed.hours ?? 0) * 1000 * SECONDS_IN_HOUR
    + (deconstructed.days ?? 0) * 1000 * SECONDS_IN_DAY
    + amount;
  if(milliseconds < 0)
    throw new Error('addMillisecondsToDuration: resulting duration cannot be negative');
  const returnValue = {...deconstructed};
  returnValue.days = Math.trunc(milliseconds / (1000 * SECONDS_IN_DAY));
  const remAfterDays = milliseconds % (1000 * SECONDS_IN_DAY);
  returnValue.hours = Math.trunc(remAfterDays / (1000 * SECONDS_IN_HOUR));
  const remAfterHours = remAfterDays % (1000 * SECONDS_IN_HOUR);
  returnValue.minutes = Math.trunc(remAfterHours / (1000 * SECONDS_IN_MINUTE));
  const remAfterMinutes = remAfterHours % (1000 * SECONDS_IN_MINUTE);
  returnValue.seconds = Math.trunc(remAfterMinutes / 1000);
  returnValue.milliseconds = remAfterMinutes % 1000;

  return returnValue;
}
